export enum DownloadQuality {
  MP3 = 'MP3',
  ORIGINAL = 'ORIGINAL'
}
